import { render, staticRenderFns } from "./remittanceList.vue?vue&type=template&id=02e681a6&"
import script from "./remittanceList.vue?vue&type=script&lang=js&"
export * from "./remittanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports